
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrderPayDetail, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class OrderPayDetailEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    orderPayDetail: OrderPayDetail;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getOrderPayDetail()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getOrderPayDetail(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.orderPayDetail = data;
                this.onDataChanged.next(this.orderPayDetail);
                resolve(this.orderPayDetail);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('orderPayDetail/' + this.routeParams.id).subscribe((res: OrderPayDetail ) => {
                    this.orderPayDetail = res;
                    this.onDataChanged.next(this.orderPayDetail);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(orderPayDetail): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('orderPayDetail/', orderPayDetail).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(orderPayDetail): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('orderPayDetail/', orderPayDetail).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(orderPayDetail): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('orderPayDetail/' + orderPayDetail.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): OrderPayDetail {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
